import React, { useState } from "react";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Container } from "react-bootstrap";
import pdfFile1 from "../../public//media/media/reports/LIMS Annual Report 2023-2024_16-Sep-2024.pdf";
import pdfFile2 from "../../public//media/media/reports/NewsletterJanuary.pdf";
import pdfFile3 from "../../public//media/media/reports/LAND INFORMATION AND MANAGMENT SYSTEM.pdf";
import pdfFile4 from "../../public//media/media/reports/Newsletterfebruary2025.pdf";
import pdfFile5 from "../../public//media/media/reports/2.pdf";
import pdfFile6 from "../../public//media/media/reports/3.pdf";
import pdfFile7 from "../../public//media/media/reports/May.pdf";
import pdfFile8 from "../../public//media/media/reports/JUNE_Newsletter_2025.pdf";
import pdfFile9 from "../../public//media/media/reports/July_Newsletter.pdf";
import "../../../src/App.css";
import lims_logo from "../../public/media/combined_images/logo.png"
function truncateText(text, limit) {
  const words = text.split(" ");
  if (words.length > limit) {
    return words.slice(0, limit).join(" ") + "...";
  }
  return text;
}

function Career() {
  const [showModal, setShowModal] = useState(false);
  const [modalPdfUrl, setModalPdfUrl] = useState("");

  const cardData = [
    {
      title: "LIMS Annual Report",
      text: "Publishing Date: 2024-09-15",

      buttonText: "Preview",
      logo1:lims_logo,

      modalPdfUrl: pdfFile1, 
    },

    {
      title: "Newsletter LIMS - December  Edition",
      text: "Publishing Date: 2024-12-15",

      buttonText: "Preview",
      logo1:
        lims_logo,

      modalPdfUrl: pdfFile3, // Replace with the PDF file URL for this card
    },
    {
      title: "Newsletter LIMS - January Edition",
      text: "Publishing Date: 2025-01-15",

      buttonText: "Preview",
      logo1:
        lims_logo,

      modalPdfUrl: pdfFile2, // Replace with the PDF file URL for this card
    },
    {
      title: "Newsletter LIMS - February Edition",
      text: "Publishing Date: 2024-02-15",

      buttonText: "Preview",
      logo1:
        lims_logo,

      modalPdfUrl: pdfFile4, // Replace with the PDF file URL for this card
    },
    {
      title: "Newsletter LIMS - March Edition",
      text: "Publishing Date: 2025-03-15",

      buttonText: "Preview",
      logo1:
        lims_logo,

      modalPdfUrl: pdfFile5, // Replace with the PDF file URL for this card
    },
    {
      title: "Newsletter LIMS - April Edition",
      text: "Publishing Date: 2024-04-15",

      buttonText: "Preview",
      logo1:
        lims_logo,

      modalPdfUrl: pdfFile6, // Replace with the PDF file URL for this card
    },
    {
      title: "Newsletter LIMS - April Edition",
      text: "Publishing Date: 2024-04-15",

      buttonText: "Preview",
      logo1:
        lims_logo,

      modalPdfUrl: pdfFile6, // Replace with the PDF file URL for this card
    },
    {
      title: "Newsletter LIMS - MAY Edition",
      text: "Publishing Date: 2024-05-15",

      buttonText: "Preview",
      logo1:
        lims_logo,

      modalPdfUrl: pdfFile7, // Replace with the PDF file URL for this card
    },
    {
      title: "Newsletter LIMS - JUNE Edition",
      text: "Publishing Date: 2024-06-15",

      buttonText: "Preview",
      logo1:
        lims_logo,

      modalPdfUrl: pdfFile8, // Replace with the PDF file URL for this card
    },
    {
      title: "Newsletter LIMS - JULY Edition",
      text: "Publishing Date: 2024-07-15",

      buttonText: "Preview",
      logo1:
        lims_logo,

      modalPdfUrl: pdfFile9, // Replace with the PDF file URL for this card
    },
  ];

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleShowModal = (modalPdfUrl) => {
    setModalPdfUrl(modalPdfUrl);
    setShowModal(true);
  };

 return (
  <Container>
    {/* CSS Keyframes for smooth floating and scaling animation */}
    <style>
      {`
        @keyframes floatAnimation {
          0% { transform: translateY(0px) scale(1); }
          50% { transform: translateY(-8px) scale(1.04); }
          100% { transform: translateY(0px) scale(1); }
        }
      `}
    </style>

    <Row xs={1} md={3} className="g-4" style={{ marginTop: "20px" }}>
      {cardData.map((card, idx) => (
        <Col key={idx} xs={12} sm={6} md={4}>
          <Card
            style={{
              background: "#F5F7FB",
              borderRadius: "25px",
              fontFamily: "Poppins, sans-serif",
              fontSize: "14px",
              height: "390px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <Card.Body
              style={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
              }}
            >
              <Card.Title
                style={{
                  fontSize: "16px",
                  marginBottom: "10px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {truncateText(card.title, 5)}
              </Card.Title>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                <img
                  src={card.logo1}
                  alt="Logo"
                  style={{
                    width: "30px",
                    height: "30px",
                    objectFit: "contain",
                    marginRight: "10px",
                  }}
                />
                <span>{card.text}</span>
              </div>

              <hr style={{ margin: "5px 0 15px 0" }} />

              {/* Animated Center Logo Section */}
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img
                  src={card.logo1}
                  alt="Centered Logo"
                  style={{
                    width: "125px",
                    height: "125px",
                    objectFit: "contain",
                    opacity: 0.9,
                    animation: "floatAnimation 3.5s ease-in-out infinite",
                    filter: "drop-shadow(0px 8px 12px rgba(0, 0, 0, 0.08))",
                  }}
                />
              </div>
            </Card.Body>

            <Card.Footer
              className="text-center"
              style={{
                background: "#0e97ff",
                borderRadius: "17px",
                padding: "10px 20px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Button
                onClick={() => handleShowModal(card.modalPdfUrl)}
                style={{
                  borderRadius: "8px",
                  width: "150px",
                  background: "#e5e8ef",
                  border: "1px solid #dfe2e",
                  color: "black",
                }}
              >
                {card.buttonText}
              </Button>
              <a href={card.modalPdfUrl} download="example.pdf">
                <img
                  src="https://cdn-icons-png.flaticon.com/128/15525/15525195.png"
                  alt="Download"
                  style={{
                    height: "50px",
                    width: "auto",
                    marginLeft: "10px",
                  }}
                />
              </a>
            </Card.Footer>
          </Card>
        </Col>
      ))}
    </Row>

    <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
      <Modal.Header closeButton>{/* Optional Modal Title */}</Modal.Header>
      <Modal.Body>
        <div
          style={{ position: "relative", paddingBottom: "56.25%", height: 0 }}
        >
          <iframe
            src={modalPdfUrl}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              border: "none",
            }}
            title="PDF Viewer"
          ></iframe>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseModal}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  </Container>
);
}

export default Career;
